import { render, staticRenderFns } from "./text-messaging-terms-and-conditions-addendum.vue?vue&type=template&id=33817392&scoped=true&"
import script from "./text-messaging-terms-and-conditions-addendum.vue?vue&type=script&lang=js&"
export * from "./text-messaging-terms-and-conditions-addendum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33817392",
  null
  
)

export default component.exports